import AuthConstants from '../../auth/models/AuthConstants';
const { RENEW_ACCESS_TOKEN, GET_TOKENS, CLEAR_TOKENS, SET_USER_SESSION_EXPIRED, SET_USER_SESSION_ABOUT_TO_EXPIRE, LOGOUT_USER, GET_GOOGLE_SPOT_TOKENS, GET_TOKENS_SUCCESS, GET_TOKENS_FAILURE, RENEW_ACCESS_TOKEN_SUCCESS, RENEW_ACCESS_TOKEN_FAILURE, LOGOUT_USER_SUCCESS, LOGOUT_USER_FAILURE, GET_GOOGLE_SPOT_TOKENS_SUCCESS, GET_GOOGLE_SPOT_TOKENS_FAILURE, SIGN_IN_FAILURE, } = AuthConstants;
export const getTokens = (payload) => ({
    type: GET_TOKENS,
    payload,
});
export const getTokensSuccess = (response) => ({
    type: GET_TOKENS_SUCCESS,
    value: { response },
});
export const getTokensFailure = () => ({
    type: GET_TOKENS_FAILURE,
});
export const clearTokens = () => ({
    type: CLEAR_TOKENS,
});
export const renewAccessToken = (isMemberLogin) => ({
    type: RENEW_ACCESS_TOKEN,
    payload: {
        isMemberLogin,
    },
});
export const renewAccessTokenSuccess = (response) => ({
    type: RENEW_ACCESS_TOKEN_SUCCESS,
    value: { response },
});
export const renewAccessTokenFailure = () => ({
    type: RENEW_ACCESS_TOKEN_FAILURE,
});
export const userSessionExpired = (show) => ({
    type: SET_USER_SESSION_EXPIRED,
    value: show,
});
export const refreshTokenExpiring = (value) => ({
    type: SET_USER_SESSION_ABOUT_TO_EXPIRE,
    value,
});
export const logoutAction = (payload) => ({
    type: LOGOUT_USER,
    payload,
});
export const logoutSuccess = () => ({
    type: LOGOUT_USER_SUCCESS,
});
export const logoutFailure = () => ({
    type: LOGOUT_USER_FAILURE,
});
export const getGoogleTokens = (payload) => ({
    type: GET_GOOGLE_SPOT_TOKENS,
    payload,
});
export const getGoogleTokensSuccess = (response) => ({
    type: GET_GOOGLE_SPOT_TOKENS_SUCCESS,
    value: { response },
});
export const getGoogleTokensFailure = () => ({
    type: GET_GOOGLE_SPOT_TOKENS_FAILURE,
});
export const signInFailed = () => ({
    type: SIGN_IN_FAILURE,
});
